

import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import toast from "react-hot-toast";
import { base_url } from "./AgentWhitelist";
const AdminAddRoles = () => {
  const location = useLocation();
  const navigate= useNavigate();

  const [Permissions, setPermissions] = useState([
    {
      name: "whitelist",
      childs: [
        { name: "Agent Whitelist", isChecked: false },
        { name: "Customer Whitelist", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "payment",
      childs: [
        { name: "Pending Recharge", isChecked: false },
        { name: "Recharge History", isChecked: false },
        { name: "Recharge", isChecked: false },
        { name: "Bank", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "roles",
      childs: [
        { name: "Add Roles", isChecked: false },
        { name: "Read Role", isChecked: false },
        { name: "Edit Role", isChecked: false },
      ],
      isChecked:false
    },
    
    {
      name: "reports",
      childs: [
        
        { name: "Casino Bets", isChecked: false },
        { name: "Client Wallet Report", isChecked: false },
        { name: "Chips Report", isChecked: false },
        { name: "Admin Chips Report", isChecked: false },
        { name: "GGR Report", isChecked: false },
        { name: "Agent chip Report", isChecked: false },
          { name: "Turnkey History", isChecked: false },
      ],
      isChecked:false
    },
      {
    name: "customerhistory",
    childs: [
      { name: "Read Customer  History", isChecked: false }
    ],
    isChecked: false
  },

 {
  name: "currency",
  childs: [
    { name: "Create Currency", isChecked: false },
    { name: "Read Currency", isChecked: false },
    { name: "Update Currency", isChecked: false },
    { name: "Delete Currency", isChecked: false },
  ],
  isChecked: false
},
{
  name: "deletecustomer",
  childs: [
    { name: "Delete Customers", isChecked: false }
  ],
  isChecked: false
}

    

  ]);


  const [roleName, setRoleName] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [name, setName]= useState([]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleChildPerm = (parentIndex, childIndex) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm, i) => {
        if (i === parentIndex) {
          const updatedChilds = perm.childs.map((child, j) => {
            if (j === childIndex) {
              return { ...child, isChecked: !child.isChecked };
            }
            return child;
          });
          const anyChecked = updatedChilds.some((child) => child.isChecked);
  
          return { 
            ...perm, 
            childs: updatedChilds, 
            isChecked: anyChecked
          };
        }
        return perm;
      })
    );
  };
  
  
  const handleParentPerm = (index) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm, i) => {
        if (i === index) {
          const updatedChilds = perm.childs.map((child) => ({
            ...child,
            isChecked: !perm.isChecked,
          }));
          return { ...perm, isChecked: !perm.isChecked, childs: updatedChilds };
        }
        return perm;
      })
    );
  };

  const handleSelectAll = () => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm) => ({
        ...perm,
        isChecked: true,
        childs: perm.childs.map((child) => ({
          ...child,
          isChecked: true,
        })),
      }))
    );
  };
  
  const handleDeselectAll = () => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm) => ({
        ...perm,
        isChecked: false,
        childs: perm.childs.map((child) => ({
          ...child,
          isChecked: false,
        })),
      }))
    );
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const checkedPermissions = Permissions
      .map((permission) => {
        const checkedChilds = permission.childs.filter((child) => child.isChecked);
        return {
          ...permission,
          childs: checkedChilds,
          isChecked: permission.isChecked ? permission.isChecked : false,
        };
      })
      .filter((permission) => permission.childs.length > 0 || permission.isChecked);
    
    try{
      const auth=localStorage.getItem('admin');
      const resp=await axios.post(`${base_url}/api/webapi/admin/createNewRole`,
        {payload:checkedPermissions,rolename:roleName},
        {
          headers:{
            Accept:'application/json',
            Authorization:`${auth}`
          }
        }
      );
      toast.success(resp.data.message);
      navigate('/admin/roles');
    }catch(err){
      toast.error('Error while creating the roles')
      console.log(err);
    }
  };

  const fetchRoles= async(req, res)=> {
    const auth = localStorage.getItem('admin');

    try{
      const response= await axios.post(base_url+ '/api/webapi/admin/Rolelist',
        {},
        {
          headers:{
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      )

      const fullRoles= response.data.data;

      let arr=[];

      fullRoles?.map(full=> {
        const keyy= Object.keys(full);

        arr.push(keyy[0]);
        // console.log('kuyy',keyy[0]);
      });
// console.log('arr',arr);
      setName(arr);

      return arr;

    }catch(err){
      console.log('err',err);
    }
  }

  const updatePermissions = (roleNames) => {
    if (!roleNames.length) return;

    setPermissions(prevPermissions => {
        const updatedPermissions = prevPermissions.map(perm => {
            if (perm.name === 'user') {
              const staticChilds = [
                { name: "A/C chips In/Out", isChecked: false },
                { name: "View More/Edit", isChecked: false },
                { name: "Add Admin", isChecked: false }
            ];

            const dynamicChilds = roleNames.map(itemName => ({
              name: itemName,
              isChecked: false,
          }));

          return {
            ...perm,
            childs: [...dynamicChilds, ...staticChilds]
          };
            }
            return perm;
        });

        if (location.state?.roleObj) {
            const role = location.state.roleObj;
            setRoleName(Object.keys(role)[0]);

            const categoryPermissions = Object.values(role)
                .flatMap(roleArray => roleArray.map(el => Object.values(el)[0]))
                .flat();

            return updatedPermissions.map(perm => {
                const updatedChilds = perm.childs.map(child => ({
                    ...child,
                    isChecked: categoryPermissions?.includes(child.name) || child.isChecked
                }));

                return {
                    ...perm,
                    childs: updatedChilds,
                    isChecked: updatedChilds.some(child => child.isChecked)
                };
            });
        }

        return updatedPermissions;
    });
};

useEffect(() => {
    const initializeData = async () => {
        try {
            const roleNames = await fetchRoles();
            updatePermissions(roleNames);
        } catch (error) {
            console.error('Error initializing data:', error);
        }
    };

    initializeData();
}, []); // Empty dependency array for initial load

// Separate useEffect for handling location.state changes
useEffect(() => {
    if (location.state?.roleObj && name.length > 0) {
        updatePermissions(name);
    }
}, [location.state, name]);


useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="side-body padding-top">
          <h1 className="page-title">
            <i className="sidebar-mini-lock" />
            {location.state? 'Edit Role': 'Add Role'}
          </h1>
          <div id="sidebar-mini-notifications" />
          <div className="page-content container-fluid">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-bordered">
                  {/* form start */}
                  <form className="form-edit-add" onSubmit={handleSubmit}>
                    <div className="panel-body">
                      <div className="form-group">
                        <label className="form-label fw-bold">Role Name</label>
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="rolename"
                          id="rolename"
                          placeholder="Name"
                          value={roleName}
                          onChange={(e) => setRoleName(e.target.value)}
                        />
                      </div>
                      <label className="mt-4 fw-bold">Permissions</label>
                      <br />
                      <a href="##" className="permission-select-all permission" onClick={handleSelectAll}>
                        Select All
                      </a>{" "}
                      /
                      <a
                        href="##"
                        className="permission-deselect-all permission"
                        onClick={handleDeselectAll}
                      >
                        Deselect All
                      </a>
                      <ul className="permissions checkbox">
                        {/* <li>
                          <input
                            type="checkbox"
                            id="users"
                            className="permission-group mr-1"
                            checked={Permissions[0].isChecked}
                          onChange={()=>handleParentPerm(0)}
                          />
                          <label htmlFor="users" 
                          >
                            <strong>User</strong>
                          </label>
                          <ul id="users-section">
                            {Permissions[0].childs.map((el, index) => {
                              return (
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`user-${index}`}
                                    name="permissions[17]"
                                    className="the-permission mr-1 sec1"
                                    defaultValue="Read Users"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(0,index)}
                                  />
                                  <label htmlFor={`user-${index}`}>
                                    {el.name}
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </li> */}


                        <li>
                          <input
                            type="checkbox"
                            id="whitelist"
                            className="permission-group mr-1"
                            checked={Permissions[0].isChecked}
                            onChange={()=>handleParentPerm(0)}

                          />
                          <label htmlFor="whitelist" >
                            <strong>Whitelist</strong>
                          </label>
                          <ul id="whitelist-section">
                            {
                              Permissions[0].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`white-${index}`}
                                      name="permissions[0]"
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(0,index)}
                                    />
                                    <label htmlFor={`white-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                            
                          </ul>
                        </li>
                        
                        <li>
                          <input
                            type="checkbox"
                            id="recharge"
                            className="permission-group mr-1"
                            checked={Permissions[1].isChecked}
                            onChange={()=>handleParentPerm(1)}
                          />
                          <label htmlFor="recharge">
                            <strong>Payment</strong>
                          </label>
                          <ul id="recharge-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`recharge-${index}`}
                                    name="permissions[1]"
                                    className="the-permission mr-1 sec3"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`recharge-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul>
                        </li>

                        <li>
                          <input
                            type="checkbox"
                            id="roles"
                            className="permission-group mr-1"
                            checked={Permissions[2].isChecked}
                            onChange={()=>handleParentPerm(2)}
                          />
                          <label htmlFor="roles" >
                            <strong>Roles</strong>
                          </label>
                          <ul id="roles-section">
                            {
                              Permissions[2].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rol-${index}`}
                                      className="the-permission mr-1 sec16"
                                      name="permissions[2]"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(2,index)}
                                    />
                                    <label htmlFor={`rol-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </li>

                        <li>
                          <input
                            type="checkbox"
                            id="reports"
                            className="permission-group mr-1"
                            checked={Permissions[3].isChecked}
                            onChange={()=>handleParentPerm(3)}

                          />
                          <label htmlFor="reports" >
                            <strong>Reports</strong>
                          </label>
                          <ul id="reports-section">
                            {
                              Permissions[3].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      name="permissions[3]"
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(3,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                            
                          </ul>
                        </li>
<li>
  <input
    type="checkbox"
    id="customerHistory"
    className="permission-group mr-1"
    checked={Permissions[4]?.isChecked || false}
    onChange={() => handleParentPerm(4)}
  />
  <label htmlFor="customerHistory">
    <strong>Customer Deposit History</strong>
  </label>
  <ul id="customerHistory-section">
    {Permissions[4]?.childs?.map((el, index) => (
      <li key={index}>
        <input
          type="checkbox"
          id={`customerHistory-${index}`}
          className="the-permission mr-1 sec16"
          name="permissions[4]"
          checked={el.isChecked}
          onChange={() => handleChildPerm(4, index)}
        />
        <label htmlFor={`customerHistory-${index}`}>{el.name}</label>
      </li>
    ))}
  </ul>
</li>


<li>
  <input
    type="checkbox"
    id="currency"
    className="permission-group mr-1"
    checked={Permissions[5]?.isChecked || false}
    onChange={() => handleParentPerm(5)}
  />
  <label htmlFor="currency">
    <strong>Currency</strong>
  </label>

  <ul id="currency-section">
    {Permissions[5]?.childs?.map((el, index) => (
      <li key={index}>
        <input
          type="checkbox"
          id={`currency-${index}`}
          name="permissions[5]"
          className="the-permission mr-1"
          checked={el.isChecked}
          onChange={() => handleChildPerm(5, index)}
        />
        <label htmlFor={`currency-${index}`}>{el.name}</label>
      </li>
    ))}
  </ul>
</li>

<li>
  <input
    type="checkbox"
    id="deleteCustomer"
    className="permission-group mr-1"
    checked={Permissions[6]?.isChecked || false}
    onChange={() => handleParentPerm(6)}
  />

  <label htmlFor="deleteCustomer">
    <strong>Delete Customer</strong>
  </label>

  <ul id="deleteCustomer-section">
    {Permissions[6]?.childs?.map((el, index) => (
      <li key={index}>
        <input
          type="checkbox"
          id={`deleteCustomer-${index}`}
          name="permissions[6]"
          className="the-permission mr-1"
          checked={el.isChecked}
          onChange={() => handleChildPerm(6, index)}
        />

        <label htmlFor={`deleteCustomer-${index}`}>
          {el.name}
        </label>
      </li>
    ))}
  </ul>
</li>




                        

                        

                      </ul>
                      <div className="panel-footer">
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary"
                          fdprocessedid="3x94fl"
                        >
                          {location.state? 'Update': 'Submit'}
                        </button>
                        
                      </div>
                    </div>
                 
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAddRoles;
